import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@emotion/react";
import { theme } from "./WorkFinitySRC/Components/common/theme";
import { BrowserRouter } from "react-router-dom";
import store from "./WorkFinitySRC/Store/store";
// import { PersistGate } from 'redux-persist/integration/react'


const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  //<MsalProvider instance={msalInstance}>
  <React.StrictMode>
   
   <Provider store={store}>
    <BrowserRouter>
   <ThemeProvider theme={theme} >
   <App  />
   </ThemeProvider>
    
     
    </BrowserRouter>
    </Provider>
    
  </React.StrictMode>
  //</MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
